import { createSlice, SliceCaseReducers } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationShared } from '../index';
import { FC, useCallback } from 'react';

export interface ProfileTabsSliceStates {
    tabs: Record<string, string>;
    selected: string;
}
export const ProfileTabsSlice = createSlice<
    ProfileTabsSliceStates,
    SliceCaseReducers<ProfileTabsSliceStates>,
    'profileTabs'
>({
    name: 'profileTabs',
    initialState: {
        tabs: {},
        selected: '',
    },
    reducers: {
        addTab: (state, action) => {
            state.tabs[action.payload.key] = action.payload.title;
        },
        select: (state, action) => {
            state.selected = action.payload;
        },
    },
});

export const profileTabsReducer = ProfileTabsSlice.reducer;

export const useProfileTabs = () => {
    const selector = useSelector((store: { profileTabs: ProfileTabsSliceStates }) => store.profileTabs);
    const dispatch = useDispatch();

    const add = useCallback(
        (key: string, title: string, component: FC<{ profileId: string }>) => {
            ApplicationShared.profileTabs[key] = {
                title,
                component,
            };
            dispatch(ProfileTabsSlice.actions.addTab({ key, title }));
        },
        [dispatch],
    );
    const update = useCallback(
        (key: string, title: string) => {
            dispatch(ProfileTabsSlice.actions.addTab({ key, title }));
        },
        [dispatch],
    );

    const select = useCallback(
        (key: string) => {
            dispatch(ProfileTabsSlice.actions.select(key));
        },
        [dispatch],
    );

    return {
        tabs: selector.tabs,
        selected: selector.selected,
        add,
        select,
        update,
    };
};
import { createSlice, SliceCaseReducers } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationShared } from '../index';
import { FC, useCallback } from 'react';

export interface ProfileTabsSliceStates {
    tabs: Record<string, string>;
    selected: string;
}
export const ProfileTabsSlice = createSlice<
    ProfileTabsSliceStates,
    SliceCaseReducers<ProfileTabsSliceStates>,
    'profileTabs'
>({
    name: 'profileTabs',
    initialState: {
        tabs: {},
        selected: '',
    },
    reducers: {
        addTab: (state, action) => {
            state.tabs[action.payload.key] = action.payload.title;
        },
        select: (state, action) => {
            state.selected = action.payload;
        },
    },
});

export const profileTabsReducer = ProfileTabsSlice.reducer;

export const useProfileTabs = () => {
    const selector = useSelector((store: { profileTabs: ProfileTabsSliceStates }) => store.profileTabs);
    const dispatch = useDispatch();

    const add = useCallback(
        (key: string, title: string, component: FC<{ profileId: string }>) => {
            ApplicationShared.profileTabs[key] = {
                title,
                component,
            };
            dispatch(ProfileTabsSlice.actions.addTab({ key, title }));
        },
        [dispatch],
    );
    const update = useCallback(
        (key: string, title: string) => {
            dispatch(ProfileTabsSlice.actions.addTab({ key, title }));
        },
        [dispatch],
    );

    const select = useCallback(
        (key: string) => {
            dispatch(ProfileTabsSlice.actions.select(key));
        },
        [dispatch],
    );

    return {
        tabs: selector.tabs,
        selected: selector.selected,
        add,
        select,
        update,
    };
};
